import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { setFontVariant } from "@similarweb/styles";
import { DisclaimerContainer } from "app/components/React/Banner/Disclaimer";

const { carbon } = colorsPalettes;

const SaveModalWrapper = styled.div`
    width: 400px;
    padding: 20px 24px;
`;

export const Title = styled.div`
    ${setFontVariant("h5", carbon[500])};
    line-height: 24px;
    margin-bottom: 36px;
`;

export const Subtitle = styled.div`
    ${setFontVariant("body1", carbon[400])};
    margin-bottom: 16px;
`;

export const InputContainer = styled.div`
    ${setFontVariant("input2", carbon[200])};
    margin-bottom: 40px;
`;

export const ButtonsContainer = styled.div`
    display: flex;
    justify-content: end;
    align-items: center;
    gap: 5px;
`;

export const DisclaimerWrapper = styled(DisclaimerContainer)`
    ${setFontVariant("caption", carbon[300])};
`;
